export const annotationPrefix = 'ak-editor-annotation';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const AnnotationSharedClassNames = {
	focus: `${annotationPrefix}-focus`,
	blur: `${annotationPrefix}-blur`,
	draft: `${annotationPrefix}-draft`,
	hover: `${annotationPrefix}-hover`,
};

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const blockAnnotationPrefix = 'ak-editor-block-annotation';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const BlockAnnotationSharedClassNames = {
	focus: `${blockAnnotationPrefix}-focus`,
	blur: `${blockAnnotationPrefix}-blur`,
	draft: `${blockAnnotationPrefix}-draft`,
};
